import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOnboardingStatsPayloadState } from '@app-store/slices/companyStatistics/onboardingStats'

interface TaskAction extends Action {
    payload: IOnboardingStatsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.onboardingStats

function* onboardingStatsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/onboarding-status/${payload.eventId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* onboardingStatsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, onboardingStatsSagaTask)
}

export default onboardingStatsSaga
